@import "@workbench/core/dist/scss/utility";

.toggle-button {
  margin: 0 auto var(--wb-spacing-xs, 1rem);
  display: block;
  width: fit-content;
}

.category-label {
  @include wb-text("m");
}
